<template>
    <modal height="auto" width="60%" :scrollable="true" name="operation-info" classes="modal_default" :clickToClose="true" data-testid="visit-operation-info">
        <div class="card">
            <div class="card-header">
                <h3>{{ operation.code }} - {{ operation.name }}</h3>
            </div>
            <div class="card-body">
                <div class="row m-0">
                    <div class="col-sm-3 p-0">
                        <h4>{{ operation.point_total }} bodů</h4>
                    </div>
                    <div class="col-sm-3 p-0">
                        <h4>{{ operation.duration }} minut</h4>
                    </div>
                </div>
                <hr>
                <h4 class="card-title">popis</h4>
                <p class="card-text">{{ operation.description !== "" ? operation.description : '-' }}</p>
                <hr>
                <h4 class="card-title">čím výkon začíná</h4>
                <p class="card-text">{{ operation.start_description !== "" ? operation.start_description : '-' }}</p>
                <hr>
                <h4 class="card-title">obsah a rozsah výkonu</h4>
                <p class="card-text">{{ operation.scope_description !== "" ? operation.scope_description : '-' }}</p>
                <hr>
                <h4 class="card-title">čím výkon končí</h4>
                <p class="card-text">{{ operation.end_description !== "" ? operation.end_description : '-' }}</p>
                <hr>
                <h4 class="card-title">podmínky</h4>
                <p class="card-text">{{ operation.condition_description !== "" ? operation.condition_description : '-' }}</p>
            </div>
        </div>
    </modal>
</template>

<script>
  // import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        //
      }
    },
    props: ['operation'],
    // mixins: [apiMixin],
    watch: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }


</style>



// WEBPACK FOOTER //
// src/views/Visit/modals/OperationInfo.vue?79fc9637